import type { Layer } from '@geosoft/viewer-sdk';
import { Icon, Stack, Text, tokens } from '@/design';

interface LayerPreviewSwatchProps {
  layer: Layer;
  size?: 'row' | 'drawer';
}

function swatchIcon(layer: Layer): 'map' | 'layers' | 'terrain' {
  if (layer.kind === 'raster') return 'map';
  if (layer.kind === 'vector') return 'layers';
  return 'terrain';
}

export function LayerPreviewSwatch({ layer, size = 'row' }: LayerPreviewSwatchProps) {
  const isDrawer = size === 'drawer';
  const side = isDrawer ? tokens.width.popoverSm : tokens.density.touchMin;
  return (
    <div
      role="img"
      aria-label={`${layer.label ?? layer.id} preview swatch`}
      style={{
        width: side,
        height: side,
        borderRadius: tokens.radius.md,
        border: tokens.border.thin,
        background: tokens.color.canvas.light ?? tokens.color.surface[2],
        display: 'grid',
        placeItems: 'center',
        flex: '0 0 auto',
      }}
    >
      <Stack direction="column" align="center" gap={1}>
        <Icon name={swatchIcon(layer)} size={20} decorative />
        <Text variant="caption" as="span" style={{ color: tokens.color.ink.secondary }}>
          {layer.kind.toUpperCase()}
        </Text>
      </Stack>
    </div>
  );
}
